export enum OperationStatus {
  started = 'STARTED',
  denied = 'DENIED',
  expired = 'EXPIRED',
  blacklisted = 'BLACKLISTED',
  succeeded = 'SUCCEEDED',
  cancelled = 'CANCELLED',
  error = 'ERROR',
}

export enum OperationType {
  onboarding = 'ONBOARDING',
  authentication = 'AUTHENTICATION',
}

export type OperationsFilter = {
  text?: string;
  fromTimeStamp?: string;
  status?: OperationStatus;
  family?: OperationType;
};
